<!--
 * @Author: qinmengyuan
 * @Date: 2024-06-20 11:29:06
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-19 10:12:36
 * @FilePath: \onetab\src\components\NewFind.vue
-->
<template>
  <div class="list" v-loading="loading" ref="listRef" @scroll="handleScroll">
    <div class="item-cont" ref="contRef">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="handleComp(item)"
      >
        <div class="icon" :style="{ background: `url(${item.logo})` }"></div>
        <div class="detail">
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.name }}</div>
        </div>
        <div class="before">
          <RaIcon icon="Plus" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { addBookmark, getNewFinds } from '@/api/baseApi';
import { ref, onMounted } from 'vue';
import { RaIcon } from '@rafter/icon';
import { bookmarks } from '@/store/bookmarks';
import { RaMessage } from '@rafter/pc';
const listRef = ref();
const contRef = ref();
const loading = ref(false);
const list = ref([]);
const page = ref(1);
const checked = ref({});
const getList = () => {
  loading.value = true;
  getNewFinds({ page: page.value, size: 28 })
    .then((res) => {
      if (res.data.code === 200) {
        list.value = [...list.value, ...(res.data.data?.data || [])];
      }
    })
    .catch((err) => {
      RaMessage({
        type: 'error',
        message: '接口出错',
      });
    })
    .finally(() => {
      loading.value = false;
    });
};
const handleComp = (item) => {
  checked.value = item;
  window['_paq'].push(['trackEvent', '书签', '常用新增', checked.value.url, 1]);

  addBookmark({
    type: checked.value.type_id > 14 ? 3 : 1,
    name: checked.value.name,
    url: checked.value.url,
    category_uuid: bookmarks.getActive()?.uuid,
    icon: checked.value.logo,
    order: bookmarks.getActive()?.bookmarks.length + 1,
    describe: checked.value.describe ?? '',
  })
    .then((res) => {
      RaMessage({
        type: 'success',
        message: '添加成功',
      });

      bookmarks.addOneToActive(res);
    })
    .catch((err) => {
      RaMessage({
        type: 'error',
        message: '接口出错',
      });
    });
};
onMounted(() => {
  getList();
});
const handleScroll = (event) => {
  const totalHeight = contRef.value?.offsetHeight + 10;
  const scrollHeight = listRef.value.scrollTop + listRef.value?.offsetHeight;

  if (totalHeight <= scrollHeight) {
    page.value += 1;
    getList();
  }
};
</script>
<style lang="scss" scoped>
.list {
  flex: 1;
  overflow: auto;
  padding: 5px;
  margin: -5px;
  ::v-deep(.ra-loading-mask) {
    background-color: transparent;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  /* 隐藏滚动条轨道 */
  &::-webkit-scrollbar-track {
    display: none;
  }

  /* 隐藏滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  .item-cont {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
  }
  .item {
    display: flex;
    width: 260px;
    padding: var(--spacing-8, 16px) 20px;
    align-items: center;
    gap: var(--spacing-8, 16px);
    border-radius: 16px;
    background: var(--background-on-background, rgba(250, 250, 250, 0.9));
    position: relative;
    .before {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-10%, -10%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      background-color: #2cd142;
      opacity: 0;
      color: rgba(255, 255, 255, 0.9);
    }
    &:hover {
      .before {
        opacity: 1;
      }
    }
    .icon {
      width: 56px;
      height: 56px;
      border-radius: 8.75px;
      background: #283567;
      background-position: center !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
    }
    .detail {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .desc {
        color: var(--Text-on-surface-tertiary, #787f8f);
        text-align: justify;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px; /* 133.333% */
      }
    }
  }
}
</style>
